import { Component } from '@angular/core';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { FormSubmissionService } from '@app/finxone-web-frontend/app/lib/services/form-submission-service/form-submission-service.service';
import { AccountState } from '@app/finxone-web-frontend/app/lib/state/account.state';
import { FormActionState } from '@app/finxone-web-frontend/app/lib/state/form-submision.state';
import { FormActionTypeEnum } from '@finxone-platform/form-action';
import { AccountInfoType } from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { FormSubmitter } from '../form-widgets/form-submitter/form-submitter.component';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-edit-beneficiary-address',
  templateUrl: './edit-beneficiary-address.component.html',
})
export class EditBeneficiaryAddressComponent extends FormSubmitter {
  public formActionStateData: { [key: string]: string };
  public editBeneficiarySepa = true;
  public selectedAccount: AccountInfoType | undefined;
  public addressFieldsList: {
    label: string;
    title: string;
    item: { regex?: RegExp; requirement: string };
    formControlName: string;
    validated?: boolean;
  }[] = [];
  public isWorkflow = false;

  constructor(
    protected override store: Store,
    public formSubmissionService: FormSubmissionService,
    private configService: ConfigService,
  ) {
    super(store);
    this.selectedAccount = this.store.selectSnapshot(AccountState.getCurrentAccount);
    this.getFormStateData();
    this.isWorkflow = this.configService.getActiveConfigType().isWorkflow;
  }

  public getFormStateData() {
    this.formActionStateData = this.store.selectSnapshot(
      FormActionState.getFormActionState,
    )?.response?.formData;
  }

  public valueChanges(addressDetails: any) {
    const formActionStateData = this.store.selectSnapshot(
      FormActionState.getFormActionStateWithId(FormActionTypeEnum.EDIT_BENEFICIARY),
    );
    const payload = {
      ...formActionStateData?.formData?.payload,
      addressLine1: addressDetails.address.addressLine1,
      addressLine2: addressDetails.address.addressLine2 ?? '',
      addressLine3: addressDetails.address.addressLine3 ?? '',
      addressLine4: addressDetails.address.addressLine4 ?? '',
      addressCity: addressDetails.address.city,
      addressState: addressDetails.address.state,
      addressCountry: addressDetails.address.country,
      addressPostCode: addressDetails.address.postCode,
    };
    this.formSubmissionService.submitIndividualForm(addressDetails.address, '');
    this.formSubmissionService.submitIndividualForm({ payload }, '', FormActionTypeEnum.EDIT_BENEFICIARY);
  }
}
